import React from 'react';

function Pagination({ totalPosts, postsPerPage, setCurrentPage, currentPage }) {
    const totalPages = Math.ceil(totalPosts / postsPerPage);
    let pages = [];

    if (totalPages > 1) {
        if (totalPages <= 5) {
            // If there are fewer than or equal to 5 pages, show all pages
            pages = Array.from({ length: totalPages }, (_, i) => i + 1);
        } else {
            // Show first 2 pages, last 2 pages, and the current page
            pages = [1, 2, '...', totalPages - 1, totalPages];
            if (currentPage > 3 && currentPage < totalPages - 2) {
                pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
            } else if (currentPage <= 5) {
                pages = [1, 2, 3, 4, 5, '...', totalPages];
            } else {
                pages = [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            }
        }
    }


    const handleClick = (page) => {
        if (page !== '...') {
            setCurrentPage(page);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className='flex flex-wrap justify-center'>
            {pages.map((page, index) => {
                return (
                    <button
                        key={index}
                        onClick={() => handleClick(page)}
                        className={`w-9 h-9 flex items-center justify-center rounded-full mx-1 ${
                            page === currentPage
                                ? "bg-gray-200 text-black"
                                : "hover:bg-gray-100 text-gray-700"
                        } ${page === '...' ? 'cursor-default' : ''}`}
                        disabled={page === '...'}
                    >
                        {page}
                    </button>
                );
            })}
        </div>
    );
}

export default Pagination;